'use client';

import React, { useEffect } from 'react';

export default function PWARegister() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker?.register('/sw.js', { scope: '/' })?.then((registration) => {
          // Check for updates periodically
          registration?.addEventListener('updatefound', () => {
            const newWorker = registration?.installing;
            if (newWorker) {
              newWorker?.addEventListener('statechange', () => {
                if (newWorker?.state === 'installed' && navigator.serviceWorker?.controller) {
                  // New version available — could show update toast here
                  newWorker?.postMessage({ type: 'SKIP_WAITING' });
                }
              });
            }
          });
        })?.catch(() => {
          // SW registration failed silently
        });
    }
  }, []);

  return null;
}
